// awami.in, every page: the phone menu opens the header's links as a sheet.
const menuButton = document.querySelector("[data-menu-button]");
const menuSheet = document.getElementById("menu-sheet");

if (menuButton && menuSheet) {
	menuButton.addEventListener("click", () => {
		const isOpen = menuButton.getAttribute("aria-expanded") === "true";
		menuButton.setAttribute("aria-expanded", String(!isOpen));
		menuSheet.hidden = isOpen;
	});
	menuSheet.addEventListener("click", (event) => {
		if (event.target.closest("a")) {
			menuButton.setAttribute("aria-expanded", "false");
			menuSheet.hidden = true;
		}
	});
}
